import ROUTE_NAME from "@/router/router.const";

export default {
  path: "/404",
  alias: "*",
  name: ROUTE_NAME.NOT_FOUND_GENERAL,
  component: () => import("@/modules/stuff/NotFoundGeneral.page"),
};
